var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveBtnProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8354 18.1397C39.1127 37.5291 4.16622 45.5619 0.283203 18.1397C0.283203 -1.24968 34.9524 -9.28242 38.8354 18.1397Z",
    fill: "#B4A7AF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0183 20.6327C28.2123 18.414 28.1016 16.1807 27.741 13.985L23.4697 9.83005C19.5867 9.55307 15.7035 9.55307 11.8208 9.83005C11.1274 15.0702 11.1274 20.3784 11.8208 25.6185C17.2568 26.4495 22.7763 26.4495 28.1846 25.6185L27.9072 20.6327H28.0183ZM19.6978 23.1256C18.9766 23.1256 18.2553 22.8337 17.7285 22.3143C17.2291 21.7947 16.9241 21.0903 16.9241 20.3557V19.5248C17.0903 19.0071 17.4232 18.5611 17.8948 18.2591C18.3387 17.9575 18.8655 17.8179 19.4204 17.8628C19.9472 17.8716 20.4745 18.0329 20.918 18.3276C21.3618 18.6223 21.6945 19.0378 21.9163 19.5248C22.1939 19.8843 22.3323 20.3217 22.3323 20.7712C22.3323 21.2208 22.1939 21.6581 21.9163 22.0177C21.0844 22.5717 20.5296 23.1256 19.6978 23.1256ZM22.1939 14.8159H13.5957V12.046H21.9163C21.9163 12.323 21.9162 12.046 22.1939 12.6V14.8159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveBtnProduct);
export default __webpack_public_path__ + "static/media/save-btn-product.009752a179a180e0a6b1dcc68a7f889d.svg";
export { ForwardRef as ReactComponent };